import {writable} from '@convincely/components/src/library.js';
import {reusable} from '@convincely/utils/lib/services/convincely.js';
import {parseUrlParams} from '@convincely/utils/lib/url-params.js';
import {widgetStore} from '../Customiser/store.js';

let _widgetStore = {};
let previousWidgetStoreValue;

const {ignoreHeaders} = parseUrlParams();
const {funnel_header, funnel_tagline, funnel_footer} = ignoreHeaders ? {} : window;

const headers = reusable('headers', {
  headline: funnel_header,
  tagline: funnel_tagline,
  footer: funnel_footer,
});

export const headline = writable(headers.headline || _widgetStore.heading);
export const tagline = writable(headers.tagline || _widgetStore.tagline);
export const footer = writable(headers.footer || _widgetStore.footer);
export const widgetHeaderLight = writable(false);

widgetStore.subscribe((value) => {
  _widgetStore = value;
  hasValueChanged(value) && updateHeadline();
  previousWidgetStoreValue = _widgetStore;
});

function hasValueChanged(value, previousValue = previousWidgetStoreValue) {
  try {
    return JSON.stringify(value) !== JSON.stringify(previousValue);
  } catch {
    return true;
  }
}

export function updateHeadline() {
  if (_widgetStore.heading) {
    headline.set(headers.headline || _widgetStore.heading);
  } else {
    headline.set(_widgetStore.heading);
  }

  if (_widgetStore.tagline) {
    tagline.set(headers.tagline || _widgetStore.tagline);
  } else {
    tagline.set(_widgetStore.tagline);
  }

  if (_widgetStore.footer) {
    footer.set(headers.footer || _widgetStore.footer);
  } else {
    footer.set(_widgetStore.footer);
  }
}

export function setWidgetHeaderLight(value) {
  widgetHeaderLight.set(value);
}
